<template>
  <div v-show="value">
    <!-- 点击蒙层不关闭弹窗 -->
    <div v-show="value" class="mask" @click="close"></div>
    <div class="mb-popup-wrapper" :style="{ background }">
      <!-- header -->
      <div class="header flex-center">
        <span :style="bindTitleStyle">{{ title }}</span>
      </div>
      <!-- body -->
      <slot></slot>
    </div>
  </div>
</template>
<script>
  // 底部弹窗
  import styleConfiguration from '@/mixins/detail/styleConfiguration'
  import { mapState } from 'vuex'
  import { isNewGenshin } from '../utils'

  export default {
    mixins: [styleConfiguration],
    props: {
      value: {
        type: Boolean,
        default: false,
      },
      title: {
        type: String,
        default: '',
      },
    },
    data() {
      return {}
    },
    computed: {
      ...mapState(['gameName']),
      bindTitleStyle() {
        if (isNewGenshin(this.gameName)) return { color: '#93735C' }
        return this.priceColor
      },
      background() {
        const { gameName } = this
        if (gameName === 'mobile-legends') return '#273758'
        if (gameName === 'pubgm') return '#303841'
        if (isNewGenshin(gameName)) return '#FFFFFF'
        const ncolor = this.discountColor.backgroundColor
        return ncolor || '#39394B'
      },
    },
    methods: {
      close() {
        this.$emit('input', false)
      },
    },
  }
</script>
<style lang="scss" scoped src="./index.scss"></style>
